<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-tabs-window v-model="activeTab" class="tab_budget_form_mobile">
                <v-window-item v-if="showFirstPageSettings" value="showFirstPageSettings">
                    <v-row no-gutters style="overflow-x: hidden">
                        <v-col cols="12" class="px-2">
                            <v-row no-gutters class="align-center">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Client</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex pl-2">
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.client.name"
                                        label="Nom client"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.client.logo"
                                        label="Logo client"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.client.address"
                                        label="Adresse client"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex pl-2">
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.client.siret"
                                        label="Siret client"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.client.ape"
                                        label="APE client"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.client.legalForm"
                                        label="Forme juridique"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="align-center my-2">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Cabinet</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" class="d-flex mt-2 pl-2">
                                    <v-select-filled
                                        v-model="themeSettings.firstPage.accountingFirm.position"
                                        :items="position"
                                        label="Position"
                                        hide-details
                                        :required="true"
                                        :disabled="readonly"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex pl-2">
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.accountingFirm.name"
                                        label="Nom cabinet"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.accountingFirm.logo"
                                        label="Logo cabinet"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.accountingFirm.address"
                                        label="Adresse cabinet"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex pl-2">
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.accountingFirm.siret"
                                        label="Siret cabinet"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="align-center my-2">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Divers</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex pl-2">
                                <v-col cols="4">
                                    <v-checkbox
                                        v-model="themeSettings.firstPage.miscellaneous.title"
                                        label="Titre document"
                                        dense
                                        hide-details="auto"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="align-center my-2">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Styles</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex pl-2">
                                <v-col cols="12" class="ml-2">
                                    <v-row no-gutters class="py-2 pt-3">
                                        <v-col class="d-flex align-center col-auto pr-3">
                                            <span class="text--secondary"
                                                >Texte informations client</span
                                            >
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-row no-gutters>
                                                <v-col cols="4" class="d-flex pl-2">
                                                    <v-select-filled
                                                        v-model="
                                                            themeSettings.firstPage.client.style
                                                                .fontFamily
                                                        "
                                                        :items="fontFamily"
                                                        label="Police texte"
                                                        hide-details
                                                        :disabled="readonly"
                                                        density="compact"
                                                    />
                                                </v-col>
                                                <v-col cols="4" class="d-flex pl-2">
                                                    <v-select-filled
                                                        v-model="
                                                            themeSettings.firstPage.client.style
                                                                .fontWeight
                                                        "
                                                        :items="fontWeight"
                                                        label="Format texte"
                                                        hide-details
                                                        :disabled="readonly"
                                                        density="compact"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="py-2 pt-3">
                                        <v-col class="d-flex align-center col-auto pr-3">
                                            <span class="text--secondary"
                                                >Texte informations cabinet</span
                                            >
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-row no-gutters>
                                                <v-col cols="4" class="d-flex pl-2">
                                                    <v-select-filled
                                                        v-model="
                                                            themeSettings.firstPage.accountingFirm
                                                                .style.fontFamily
                                                        "
                                                        :items="fontFamily"
                                                        label="Police texte"
                                                        hide-details
                                                        :disabled="readonly"
                                                        density="compact"
                                                    />
                                                </v-col>
                                                <v-col cols="4" class="d-flex pl-2">
                                                    <v-select-filled
                                                        v-model="
                                                            themeSettings.firstPage.accountingFirm
                                                                .style.fontWeight
                                                        "
                                                        :items="fontWeight"
                                                        label="Format texte"
                                                        hide-details
                                                        :disabled="readonly"
                                                        density="compact"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item v-if="showNextSettings" value="showNextSettings">
                    <v-row no-gutters style="overflow-x: hidden">
                        <v-col cols="12" class="px-2">
                            <v-row no-gutters class="py-2 pt-1">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Client</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex align-center">
                                <v-col cols="4" class="d-flex align-center pl-2">
                                    <v-radio-group
                                        v-model="themeSettings.pages.client.logo"
                                        class="d-flex align-center"
                                        inline
                                        density="compact"
                                        color="primary"
                                        :disabled="readonly"
                                    >
                                        <v-radio label="Nom" :value="false" class="pr-3" />
                                        <v-radio label="Logo" :value="true" />
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4" class="d-flex pl-2 pt-2">
                                    <v-select-filled
                                        v-model="themeSettings.pages.position.client"
                                        :items="position"
                                        label="Position Client"
                                        hide-details
                                        :required="true"
                                        :disabled="readonly"
                                        @update:model-value="
                                            checkPositionAvailable(
                                                themeSettings.pages.position.client,
                                                'client',
                                            )
                                        "
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2 pt-3 pl-2">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Cabinet</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" class="d-flex align-center pl-2">
                                    <v-radio-group
                                        v-model="themeSettings.pages.accountingFirm.logo"
                                        class="d-flex align-center"
                                        inline
                                        density="compact"
                                        color="primary"
                                        :disabled="readonly"
                                    >
                                        <v-radio label="Nom" :value="false" class="pr-3" />
                                        <v-radio label="Logo" :value="true" />
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4" class="d-flex pl-2 pt-3">
                                    <v-select-filled
                                        v-model="themeSettings.pages.position.accountingFirm"
                                        :items="position"
                                        label="Position Cabinet"
                                        hide-details
                                        :required="true"
                                        :disabled="readonly"
                                        @update:model-value="
                                            checkPositionAvailable(
                                                themeSettings.pages.position.client,
                                                'accountingFirm',
                                            )
                                        "
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="py-2 pt-3 pl-2">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Titre</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" class="d-flex pl-2">
                                    <v-radio-group
                                        v-model="themeSettings.pages.miscellaneous.title"
                                        class="d-flex align-center"
                                        inline
                                        density="compact"
                                        color="primary"
                                        :disabled="readonly"
                                    >
                                        <v-radio label="Oui" :value="true" class="pr-3" />
                                        <v-radio label="Non" :value="false" />
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="4" class="d-flex pl-2 pt-3">
                                    <v-select-filled
                                        v-model="themeSettings.pages.position.title"
                                        :items="position"
                                        label="Position Titre"
                                        hide-details
                                        :required="true"
                                        :disabled="readonly"
                                        @update:model-value="
                                            checkPositionAvailable(
                                                themeSettings.pages.position.title,
                                                'title',
                                            )
                                        "
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="align-center pl-2 my-2">
                                <v-col>
                                    <b class="pr-3">Styles des polices</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" class="d-flex mt-2 mb-2">
                                    <v-select-filled
                                        v-model="themeSettings.pages.tables.header.fontWeight"
                                        :items="fontWeight"
                                        label="En-tête"
                                        hide-details
                                        :disabled="readonly"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                    <v-select-filled
                                        v-model="themeSettings.pages.tables.rows.fontWeight"
                                        :items="fontWeight"
                                        label="Données"
                                        hide-details
                                        :disabled="readonly"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                    <v-select-filled
                                        v-model="themeSettings.pages.tables.footer.fontWeight"
                                        :items="fontWeight"
                                        label="Pied de page"
                                        hide-details
                                        :disabled="readonly"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="align-center">
                                <v-col class="d-flex align-center">
                                    <b class="pr-3">Styles des couleurs</b>
                                    <v-divider />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" class="d-flex mt-2 mb-2">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <v-text-field-filled
                                                        v-model="
                                                            themeSettings.pages.tables.header
                                                                .backgroundColor
                                                        "
                                                        v-bind="props"
                                                        label="En-tête"
                                                        readonly
                                                        :disabled="readonly"
                                                        hide-details
                                                        density="compact"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <v-color-picker
                                            v-model="
                                                themeSettings.pages.tables.header.backgroundColor
                                            "
                                            show-swatches
                                            hide-sliders
                                            hide-inputs
                                            hide-mode-switch
                                            :swatches="swatches"
                                        >
                                        </v-color-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <v-text-field-filled
                                                        v-model="
                                                            themeSettings.pages.tables.rows
                                                                .backgroundColor
                                                        "
                                                        v-bind="props"
                                                        label="Données"
                                                        readonly
                                                        :disabled="readonly"
                                                        hide-details
                                                        density="compact"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <v-color-picker
                                            v-model="
                                                themeSettings.pages.tables.rows.backgroundColor
                                            "
                                            show-swatches
                                            hide-sliders
                                            hide-inputs
                                            hide-mode-switch
                                            :swatches="swatches"
                                        >
                                        </v-color-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <v-text-field-filled
                                                        v-model="
                                                            themeSettings.pages.tables.footer
                                                                .backgroundColor
                                                        "
                                                        v-bind="props"
                                                        label="Pied de page"
                                                        readonly
                                                        :disabled="readonly"
                                                        hide-details
                                                        density="compact"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <v-color-picker
                                            v-model="
                                                themeSettings.pages.tables.footer.backgroundColor
                                            "
                                            show-swatches
                                            hide-sliders
                                            hide-inputs
                                            hide-mode-switch
                                            :swatches="swatches"
                                        >
                                        </v-color-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" class="d-flex pt-2">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <v-text-field-filled
                                                        v-model="
                                                            themeSettings.pages.tables.rows
                                                                .borderColor
                                                        "
                                                        v-bind="props"
                                                        label="Bordures"
                                                        readonly
                                                        hide-details
                                                        :disabled="readonly"
                                                        density="compact"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <v-color-picker
                                            v-model="themeSettings.pages.tables.rows.borderColor"
                                            show-swatches
                                            hide-sliders
                                            hide-inputs
                                            hide-mode-switch
                                            :swatches="swatches"
                                        >
                                        </v-color-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="4" class="d-flex pl-3">
                                    <v-checkbox
                                        v-model="themeSettings.pages.tables.rows.border"
                                        label="Bordures"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="4" class="d-flex pt-2">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <v-text-field-filled
                                                        v-model="
                                                            themeSettings.pages.tables.footer
                                                                .totalColorSeparator
                                                        "
                                                        v-bind="props"
                                                        label="Couleur séparateur"
                                                        readonly
                                                        :disabled="readonly"
                                                        hide-details
                                                        density="compact"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <v-color-picker
                                            v-model="
                                                themeSettings.pages.tables.footer
                                                    .totalColorSeparator
                                            "
                                            show-swatches
                                            hide-sliders
                                            hide-inputs
                                            hide-mode-switch
                                            :swatches="swatches"
                                        >
                                        </v-color-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="4" class="d-flex pl-3">
                                    <v-checkbox
                                        v-model="themeSettings.pages.tables.footer.borderTop"
                                        label="Séparateur Totaux"
                                        :disabled="readonly"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-tabs-window>
        </v-col>
    </v-row>
</template>
<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {},
})
export class ExportThemeMenu extends Vue {
    @Prop({ default: true }) showFirstPageSettings!: boolean;
    @Prop({ default: true }) showNextSettings!: boolean;
    @Prop({ default: true }) showStyleSettings!: boolean;
    @Prop({ default: null }) themeSettings: any;
    @Prop({ default: null }) activeTab: any;
    @Prop({ default: false }) readonly: boolean;

    activeTabStyle = "";

    position = [
        { value: "", title: "Sans" },
        { value: "top-left", title: "Haut Gauche" },
        { value: "top-right", title: "Haut Droite" },
        { value: "bottom-left", title: "Bas Gauche" },
        // {value:"bottom-right", text:"Bas Droite"}, Pour le moment seule la numerotation des pages peut-être placée en bas à droite
        // En cas de modif vérifier aussi le back => accountingDocx.ts
    ];

    positionClient = [{ value: "center", title: "Centré" }];

    fontWeight = [
        { value: "normal", title: "Normal" },
        { value: "bold", title: "Gras" },
    ];

    fontFamily = [
        { value: "serif", title: "Serif" },
        { value: "sans-serif", title: "Sans serif" },
        { value: "Georgia", title: "Georgia" },
        { value: "system-ui", title: "System UI" },
        { value: "Arial", title: "Arial" },
        // {value:"Helvetica",text:"Helvetica"},
    ];

    swatches = [
        // ['#1abc9c','#2ecc71','#16a085','#95a5a6','#7f8c8d'],
        // ['#27ae60','#3498db','#2980b9','#c0392b','#ecf0f1'],
        // ['#9b59b6','#8e44ad','#34495e','#e67e22','#e74c3c'],
        // ['#2c3e50','#f1c40f','#f39c12','#d35400','#bdc3c7'],
        ["#b2e2f2", "#b0c2f2", "#84b6f4"],
        ["#77dd77", "#b0f2c2", "#d8f8e1"],
        ["#fcb7af", "#fabfb7", "#ffe4e1"],
        ["#fdfd96", "#ffda9e", "#fdf9c4"],
        ["#ffffff", "#f5f5f5", "efefef"],
    ];

    checkPositionAvailable(position, key) {
        for (const pos in this.themeSettings.pages.position) {
            if (!(pos === key)) {
                if (this.themeSettings.pages.position[pos] === position) {
                    this.themeSettings.pages.position[pos] = "";
                }
            }
        }
    }

    colorIconStyle(string) {
        return {
            height: "20px",
            width: "20px",
            "border-radius": "10px",
            "z-index": "1",
            "background-color": this.themeSettings.pages.tables?.[string].backgroundColor || "",
        };
    }

    colorSeparator() {
        return {
            height: "20px",
            width: "20px",
            "border-radius": "10px",
            "z-index": "1",
            "background-color": this.themeSettings.pages.tables?.footer.totalColorSeparator || "",
        };
    }

    colorBorders() {
        return {
            height: "20px",
            width: "20px",
            "border-radius": "10px",
            "z-index": "1",
            "background-color": this.themeSettings.pages.tables?.rows.borderColor || "",
        };
    }
}

export default toNative(ExportThemeMenu);
</script>
